import { render, staticRenderFns } from "./ModalAddClienteDkp.vue?vue&type=template&id=46e9ce7c&scoped=true&"
import script from "./ModalAddClienteDkp.vue?vue&type=script&lang=js&"
export * from "./ModalAddClienteDkp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9ce7c",
  null
  
)

export default component.exports